import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { useThemeMode } from '@synoptic/ui-kit/theme/theme-context.js';
import { useLocation } from 'react-router';
import { getRedirectLink } from '@/routes-utils/get-redirect-link.ts';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';

export type GuestAuthButtonsProps = {
  className?: string;
  surface?: 'sidebar' | 'modal';
};

export const GuestAuthButtons = ({
  className,
  surface = 'modal',
}: GuestAuthButtonsProps) => {
  const location = useLocation();
  const isLightMode = useThemeMode() === 'light';
  const inversed = surface === 'sidebar' && isLightMode;

  return (
    <div className={className}>
      <Button size={'large'} inversed={inversed} asChild>
        <Link to={getRedirectLink(paths.signup, location.pathname)}>
          Sign up
        </Link>
      </Button>
      <Button
        size={'large'}
        variant={inversed ? 'primary' : 'secondary'}
        asChild
      >
        <Link to={getRedirectLink(paths.login, location.pathname)}>Log in</Link>
      </Button>
    </div>
  );
};
